module.exports = __webpack_public_path__ + "ff6be430adf647a558b28e79ea73c971.png";